<div class="button " [class]="class" [attr.disabled]="disable">
  <div [style]="style">
    <i-tabler *ngIf="leadingIcon" [name]="leadingIcon"></i-tabler>
    <p class="label1">{{label}}</p>
    <i-tabler *ngIf="trailingIcon" [name]="trailingIcon"></i-tabler>
  </div>
</div>
